import type { ClassNameProp } from '@library/types'
import cn from 'classnames'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import css from './Footer.css'
import { FooterBodyBlock } from './FooterBlocks'
import { FooterButtons } from './FooterButton'

/**
 * Тапочки (нижняя панель) процесса
 */
const FooterBase = forwardRef<HTMLElement, PropsWithChildren<ClassNameProp>>(function Footer(
  { children, className },
  ref,
) {
  return (
    <footer ref={ref} className={cn(css.footer, className)}>
      {children}
    </footer>
  )
})

export const Footer = Object.assign(FooterBase, {
  ExpandButton: FooterButtons,
  Body: FooterBodyBlock,
})
